module.exports = __webpack_public_path__ + "assets/img/elem1-transperent-bcg.96cfadbb.png";